import { render, staticRenderFns } from "./PageTherapistClientError.vue?vue&type=template&id=823e1df8"
import script from "./PageTherapistClientError.vue?vue&type=script&lang=js"
export * from "./PageTherapistClientError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports